import type {QueryClient} from '@tanstack/react-query';

// Que se refresca despues de guardar algo del negocio (revision del 6/10/2026).
// Los datos estan cruzados: una bolsa cambia el inventario, los totales del
// seguimiento, la asignacion de una reserva, las financiaciones, las
// revisiones de calidad, el historial de cargas y los logros. Antes cada
// guardado refrescaba solo una parte y otras pantallas quedaban viejas.
// Marcar una consulta como vieja solo vuelve a pedir las que estan en
// pantalla; las demas se piden al abrirlas.
const DATOS_DEL_NEGOCIO = [
  'inventario',
  'seguimiento',
  'asignacion',
  'reservas',
  'financiacion',
  'cashflow',
  'mineros',
  'dore',
  'transporte',
  'calidad',
  'cargas',
  'navieras',
  'logros',
] as const;

export function refrescarDatos(cliente: QueryClient) {
  return Promise.all(DATOS_DEL_NEGOCIO.map(clave => cliente.invalidateQueries({queryKey: [clave]})));
}
